/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section2_TitleInputs */

const en_privacy_section2_title = /** @type {(inputs: Privacy_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data We Do NOT Collect`)
};

const ko_privacy_section2_title = /** @type {(inputs: Privacy_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수집하지 않는 데이터`)
};

const ja_privacy_section2_title = /** @type {(inputs: Privacy_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`収集しないデータ`)
};

/**
* | output |
* | --- |
* | "Data We Do NOT Collect" |
*
* @param {Privacy_Section2_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section2_title = /** @type {((inputs?: Privacy_Section2_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section2_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section2_title(inputs)
	if (locale === "ko") return ko_privacy_section2_title(inputs)
	return ja_privacy_section2_title(inputs)
});